import { axiosInstance } from "api/axios";
import { IRiskProfileReminderStatus, ISnoozeRiskProfileReminderResponse } from "./types";

export const getRiskProfileReminderStatus = async (): Promise<IRiskProfileReminderStatus> => {
	const { data } = await axiosInstance.get("/risk-profile/reminder-status");
	return data;
};

export const snoozeRiskProfileReminder = async (): Promise<ISnoozeRiskProfileReminderResponse> => {
	const { data } = await axiosInstance.post(`/risk-profile/snooze-reminder`);
	return data;
};
